import React, { useState } from "react";
import { SURVEY_STATUS } from "store/reducers/surveyReducer";
import ViewResponseModal from "./ViewResponseModal";
import SurveyService from "services/SurveyService";
import fileDownload from "js-file-download";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useToasts } from "react-toast-notifications";

export default ({
  items,
  surveyId,
  teamId,
  status,
  dispatch,
  reload,
  answeredUser,
  totalUser,
}) => {
  const { addToast } = useToasts();
  const [viewResponse, setViewResponse] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (downloading) return;
    
    setDownloading(true);
    try {
      const response = await SurveyService.exportSurvey(surveyId, teamId);
      
      // Get filename from Content-Disposition header or use default
      const contentDisposition = response.headers["content-disposition"];
      let filename = `survey_${surveyId}_responses.csv`;
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }
      
      fileDownload(response.data, filename);
      addToast("Survey responses downloaded successfully.", {
        appearance: "success",
      });
    } catch (error) {
      console.error("Error downloading survey responses:", error);
      addToast("Failed to download survey responses. Please try again.", {
        appearance: "error",
      });
    } finally {
      setDownloading(false);
    }
  };

  if (items.length === 0) {
    return (
      <div className="questionListContainer mt-2 d-flex justify-content-center p-2">
        Add questions to this survey
      </div>
    );
  }

  return (
    <div>
      <div className="questionListContainer">
        {items.map(({ question, type, id }) => (
          <div className="questionItem" key={id}>
            {question}
            <span className="badge badge-primary badge-pill text-primary">
              {type}
            </span>
          </div>
        ))}
      </div>
      {items.length > 0 && status === SURVEY_STATUS.INACTIVE && (
        <div className="mt-5 d-flex justify-content-end flex-column">
          <div style={{ marginRight: "2rem" }}>
            Responses:{" "}
            <span className="listCount">
              {answeredUser}/{totalUser}
            </span>
          </div>
          <div className="d-flex gap-2" style={{ marginRight: "10px" }}>
            <button
              type="submit"
              className="viewResponseBtn btn-sm"
              onClick={() => setViewResponse(true)}
            >
              View Responses
            </button>
            <button
              type="button"
              className="viewResponseBtn btn-sm"
              onClick={handleDownload}
              disabled={downloading}
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FontAwesomeIcon icon={faDownload} />
              {downloading ? "Downloading..." : "Download Responses"}
            </button>
          </div>
        </div>
      )}

      {viewResponse && (
        <ViewResponseModal
          onClose={() => {
            setViewResponse(false);
          }}
          surveyId={surveyId}
          teamId={teamId}
        />
      )}
    </div>
  );
};
